import React from "react";

export default function DescriptionSecondary({ text }) {
  return (
    <>
      <div className="mt-2">
        <div className="col-sm-12">
          <p className={`desc-text text-gray`}>
            {text}
          </p>
        </div>
      </div>
    </>
  );
}
